<template>
  <ul class="animated fadeIn">
    <li v-for="(item, subIndex) in dataMenu" v-bind:key="subIndex">
      <i class="fas fa-folder-open text-third"></i> {{ item.nome }}<i class="fas fa-lock text-third treeview-options-25"></i><i class="fas fa-plus-circle text-third treeview-options-15 pointer" @click="onNewItemMenu(obj, { id: item.id, nome: item.nome}, 1)"></i>
      <TreviewItemGed v-if="dataFilhos" ref="TreviewItemGed" v-on:New="onNewItemMenu" :menu="dataMenu" :pai="dataPai" :filhos="onGetChildrenMenu(dataMenu, item.id)" />
    </li>
  </ul>
</template>
<script>
import TreviewItemGed from './treviewItemGed.vue'

export default {
  name: 'TreeviewItemGed',
  data () {
    return {
    }
  },
  components: {
    TreviewItemGed
  },
  props: {
    menu: {
      type: Object,
      required: true
    },
    pai: {
      type: Number,
      required: true
    },
    filhos: {
      type: Array,
      required: false
    }
  },
  computed: {
    dataMenu () {
      return this.menu
    },
    dataPai () {
      return this.pai
    },
    dataFilhos () {
      return this.filhos
    }
  },
  methods: {
    onNewItemMenu (secao, menu, nivel) {
      this.$emit('New', secao, menu, nivel)
    },
    onGetChildrenMenu (menu, pai) {
      let children = []
      if (menu) {
        menu.forEach(element => {
          if (element.menuId === pai) {
            children.push(element)
          }
        })
      }
      return children
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/ged/leftcontent/components/Treeview/treviewItemGed.vue